import { FC } from 'react';
import errorImg from '../assets/img/lock-with-keyhole.svg';
import { HttpErrorDisplayTemplate } from '../errors/HttpErrorDisplayTemplate';
import { ForbiddenVariant, Spinner } from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './Forbidden.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory('forbidden');
addTranslations(translations);

// This component can be used in two ways:
// 1) Manual access check using isAllowed prop and showing spinner while the check is in progress
// 2) Just rendering forbidden message, no access check
export type ForbiddenProps =
  | {
      isAllowed?: boolean;
      children?: React.ReactNode;
      variant?: ForbiddenVariant;
    }
  | {
      variant?: ForbiddenVariant;
    };

export const Forbidden: FC<ForbiddenProps> = (props) => {
  const variant = props.variant ?? 'forbidden';

  if ('isAllowed' in props) {
    const { isAllowed, children } = props;
    if (isAllowed === undefined) {
      return <Spinner />;
    } else if (isAllowed) {
      return <>{children}</>;
    } else {
      return <ForbiddenInner variant={variant} />;
    }
  }

  return <ForbiddenInner variant={variant} />;
};

const ForbiddenInner: FC<{ variant: ForbiddenVariant }> = ({ variant }) => {
  const { t } = useTranslation();
  return (
    <HttpErrorDisplayTemplate imgSrc={errorImg} title={t('title')}>
      {t(`code.${variant}.description`)}
    </HttpErrorDisplayTemplate>
  );
};
